import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'manage-calendar-container',
    templateUrl: './manage-calendar.component.html'
})
export class ManageCalendarComponent {}
